import {ProductPriceCreateDto, ProductPriceUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import {InputNumber} from "antd";

const formItems: CrudFormItemProps[] = [
    {
        name: nameof<ProductPriceCreateDto>("unitValue"),
        label: "Wartość (zł)",
        rules: [
            {required: true, message: 'To pole jest wymagane'},
        ],

    },
    {
        name: nameof<ProductPriceCreateDto>("unit"),
        label: "Jednostka miary",
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
    },
    {
        name: nameof<ProductPriceCreateDto>("taxRate"),
        label: "Stawka podatku",
        rules: [
            {required: true, message: 'To pole jest wymagane'},
        ],
        children: <InputNumber
            max={100} min={0} style={{width: "100%"}}
            addonAfter="%" precision={0}
        />
    },
    {
        name: nameof<ProductPriceCreateDto>("unitStock"),
        label: "Stan magazynowy",
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
        children: <InputNumber min={0} precision={0} style={{width: "100%"}}/>
    }
];

export default function ProductPriceModalForm(props: ProductPriceModalProps) {
    return <CrudFormModal
        formItems={formItems}
        forceRender={true}
        destroyOnClose={true}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={"Zapisz"}
        modalCancelText={"Anuluj"}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        width={700}
    />;
}

interface ProductPriceModalProps {
    initialValues?: ProductPriceCreateDto | ProductPriceUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: ProductPriceCreateDto | ProductPriceUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
}
